/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import canIdImage from "../../assets/images/candid-seal-platinum-2025.png";
import { useLocation } from "react-router-dom";

export function Footer() {
  const location = useLocation();
  const showCandid =
    location.pathname === "/" || location.pathname === "/donate";
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles["footer"]}>
      <div className={styles["footer-wrapper"]}>
        <div>
          <p>©The Podcast Fellowship {currentYear} - all rights reserved</p>
          <div className={styles["footer-social"]}>
            <p>Follow Us</p>
            <ul className={`d-flex ${styles["social-list"]}`}>
              <a href="https://www.linkedin.com/company/71512304"><i className="icon-linkedin2"></i></a>
              <a href="https://www.tiktok.com/@the.podcast.fellowship?_t=8oUGFbo1gwR&_r=1"><i className="icon-tiktok"></i></a>
              <a href="https://www.facebook.com/podcastfellowship/"><i className="icon-facebook2"></i></a>
              <a href="https://www.instagram.com/podcastfellowship/"><i className="icon-instagram2"></i></a>
              <a href="https://www.youtube.com/@thepodcastfellowship"><i className="icon-youtube"></i></a>
            </ul>
          </div>
        </div>
        <div className={styles["footer-right"]}>
          <Link to={"/privacy-policy"}>Privacy Policy</Link>
          {showCandid && <a href="https://app.candid.org/profile/10982390/podcast-educational-foundation-86-3753638" className={styles["candid-link"]}>
            <img src={ canIdImage } alt="Candid Platinum Seal of Transparency 2025" className={styles["candid-seal"]} width="70" />
          </a>}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
